import { render, staticRenderFns } from "./ModalRemoverCategoriaEnquete.vue?vue&type=template&id=15096912&scoped=true"
import script from "./ModalRemoverCategoriaEnquete.vue?vue&type=script&lang=js"
export * from "./ModalRemoverCategoriaEnquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15096912",
  null
  
)

export default component.exports